import React, { useEffect, useRef, useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import { loadStripe } from '@stripe/stripe-js';
import { EmbeddedCheckout, EmbeddedCheckoutProvider } from '@stripe/react-stripe-js';

export default function CheckoutPay() {
  const [params] = useSearchParams();
  const sessionId = params.get('session_id');
  const [error, setError] = useState<string | null>(null);
  const [stripePromise, setStripePromise] = useState<ReturnType<typeof loadStripe> | null>(null);
  const [clientSecret, setClientSecret] = useState<string | null>(null);

  useEffect(() => {
    const mount = async () => {
      if (!sessionId) {
        setError('Missing session id');
        return;
      }
      try {
        // Fetch Stripe publishable key and session client secret
        const [cfgRes, sessRes] = await Promise.all([
          fetch('/api/checkout/config'),
          fetch(`/api/checkout/session-status/${sessionId}`)
        ]);
        const cfg = await cfgRes.json();
        const sess = await sessRes.json();
        const secret = sess.clientSecret;
        const publishableKey = cfg.publishableKey;
        if (!publishableKey) {
          setError('Stripe publishable key is missing');
          return;
        }
        if (!secret) {
          setError('Unable to retrieve client secret');
          return;
        }
        setStripePromise(loadStripe(publishableKey));
        setClientSecret(secret);
      } catch (e: any) {
        setError(e.message || 'Failed to start checkout');
      }
    };
    mount();
  }, [sessionId]);

  return (
    <div className="container mx-auto px-4 py-8">
      <h1 className="text-2xl font-bold text-white mb-4">Checkout</h1>
      {error && <div className="text-red-300">{error}</div>}
      {stripePromise && clientSecret && (
        <EmbeddedCheckoutProvider stripe={stripePromise as any} options={{ clientSecret }}>
          <EmbeddedCheckout />
        </EmbeddedCheckoutProvider>
      )}
    </div>
  );
}


